module.exports = __webpack_public_path__ + "images/emoji/telescope.f420fe4ad6fd36d1f5f9.png";